var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loading-overlay",attrs:{"role":"status"}},[_c('div',{staticClass:"loading-card"},[_c('span',{staticClass:"spinner"}),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t("Carregando")))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }